import { render } from "./contracts-modal.vue?vue&type=template&id=10499648"
import script from "./contracts-modal.vue?vue&type=script&lang=js"
export * from "./contracts-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__